<script>
import mixin from './../mixin';

import SourceSet from './SourceSet.vue';

export default {
    mixins: [mixin],
    components: { SourceSet },
    props: {
        item: Object,
    },
};
</script>

<template>
    <a :href="item.url" class="card is-flex">
        <div v-if="item.previewImage && item.previewImage.length > 0" class="card-image is-clipped is-relative">
            <source-set :imageSets="item.previewImage" />

            <div v-show="item.label" class="card-watermark has-text-weight-bold has-text-white has-line-height-normal">
                {{ item.label }}
            </div>

            <div v-show="item.label" class="card-label has-text-weight-bold has-text-white has-line-height-normal">
                {{ item.label }}
            </div>
        </div>

        <div v-if="item.title || item.intro" class="card-content is-flex-grow-1 is-flex is-flex-direction-column content">
            <h4 v-show="item.title" class="card-title title is-4">{{ item.title }}</h4>
            <p v-show="item.intro" class="block mt-auto" v-html="item.intro"></p>
        </div>
    </a>
</template>
